export default "__VITE_ASSET__MSfuvbkj__"